import useFetch from '@hooks/useFetch';
import { readCookie } from '@utils/cookies';
import { useEffect, useState } from 'react';
import { getEnrollAPIKey } from '@cont/SeeAll/utils';
import { HOST_TYPE } from '@utils/api-helper/host';
import reduxFreeFetcher from '@api/fetchers';

const useEnrollInfo = (
  testSeriesUID,
  goalUID,
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const isServer = typeof window === 'undefined';
  const searchToken = readCookie('searchToken');
  const [shouldFetch, setShouldFetch] = useState(
    isServer ? false : !!searchToken
  );
  const key = getEnrollAPIKey(testSeriesUID, goalUID);

  useEffect(() => {
    setShouldFetch(!!searchToken);
  }, [searchToken]);

  const {
    data: enrolledState,
    isLoading: isEnrollStateLoading,
    mutate: enrollStateMutate,
    isValidating: isEnrollStateValidating,
    isError
  } = useFetch(
    shouldFetch ? key : null,
    {
      useSearchToken: true,
      hostType: HOST_TYPE.TEST_SERIES
    },
    options
  );

  const onToggleEnroll = async () => {
    try {
      await reduxFreeFetcher(`v2/uplus/programmes/${testSeriesUID}/save/`, {
        requestType: 'POST',
        body: {
          enroll: !enrolledState.isEnrolled
        }
      });

      return await enrollStateMutate();
    } catch (err) {
      return {
        error: {
          message: `Unable to ${
            !enrolledState.isEnrolled ? 'enroll' : 'un-enroll'
          }. Please try again!`
        }
      };
    }
  };

  return {
    key,
    enrolledState,
    isEnrollStateLoading,
    isEnrollStateValidating,
    enrollStateMutate,
    onToggleEnroll,
    isError
  };
};

export default useEnrollInfo;
